<template>
  <div class="home" id="home">
    <!-- 头部登录 -->
    <Header-Top></Header-Top>
    <!-- 头部搜索和tabs -->
    <Header-Search
      :activeName="activeName"
      :active="active"
      :flag="1"
    ></Header-Search>
    <div class="banner">
      <div class="allshop">
        <i class="iconfont icon-liebiao"></i>
        <span class="shopplist">&nbsp;&nbsp;配件分类</span>
      </div>
      <div class="partsdh">
        <div class="navigationbanner" @mouseleave="mouseleave">
          <ul class="ul1">
            <li
              v-for="(item, index) in partsdhlist"
              :key="index"
              @mouseenter="mouseover(item.id, item.imgs, index)"
              :class="index == glideglide ? 'color377' : ''"
            >
              <span class="inconkd">
                <!-- <i class="iconfont" :class="item.icon"></i> -->
                <img
                  :src="index == glideglide ? item.icon1 : item.icon"
                  alt=""
                />
              </span>

              <span class="w112">{{ item.name }}</span>
              <span class="iconfont icon-youjiantou"></span>
            </li>
          </ul>
          <div
            class="partscontent"
            v-show="bannerconter"
            :style="{ backgroundImage: `url(${settingtp})` }"
          >
            <div class="twopartssj">
              <ul class="ul2">
                <li
                  v-for="(item, index) in partstwolist"
                  :key="index"
                  :class="index == partstwoxs ? 'color177' : ''"
                  @click="threeparts(item.id, index)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
            <div class="threepartssj">
              <ul class="ul3">
                <li
                  v-for="(item, index) in partsthreelist"
                  :key="index"
                  :class="index == partsthreexs ? 'color177' : ''"
                  @click="skipparts(item.id, index, item)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <!-- 这里插入图片 轮播图1，2，3-->
        <!-- <div class="swiper-slide">
          <img src="../../../assets/images/main/index/banner2.jpg" alt="" />
        </div> -->
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerIMG"
          :key="index"
          :style="
            item.background == ''
              ? 'background:none'
              : 'background:' + item.background
          "
        >
          <div class="picture">
            <img class="imgs3" :src="item.imgs" alt="" />
            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
        <!-- <div class="swiper-slide">
          <img :src="item.bannerUrl" alt="" />
        </div>
        <div class="swiper-slide">
          <img :src="item.bannerUrl" alt="" />
        </div> -->
      </div>
      <!-- 分别为  前进  后退 按钮 -->
      <!-- 分页器 -->
    </div>
    <!-- <div style="height:40px"></div> -->
    <div class="slidecontent">
      <!-- 热销配件 -->
      <div class="NewProducts w" :id="slideshow ? '0' : ''" v-show="hotparts">
        <div class="common-incon backFE">
          <p class="color10c">热销配件</p>
        </div>
        <div class="recommend">
          <img class="img" :src="adverting || adverting1" alt="" />
          <div class="recommend_content">
            <div class="recommend_top">
              <ul class="recommend_ul">
                <li
                  v-for="(item, index) in contentlist.slice(0, 2)"
                  :key="index"
                  @click="enterPAT(item)"
                >
                  <div class="recommendtp">
                    <img class="imgs" :src="item.imgurl || blankshop" alt="" />
                  </div>
                  <div class="recommend_js">
                    <div @click="enterPAT(item)" class="name1 tradeline">
                      <Tooltip
                        :content="item.partComplexName"
                        max-width="200"
                        theme="light"
                      >
                        <p class="p1">
                          {{ item.oeCode }}
                        </p>
                        <p class="p2">{{ item.carBrandName }}</p>
                        <p class="p3">{{ item.stdNameJp }}</p>
                      </Tooltip>
                    </div>
                    <div
                      class="name2 tradeline w33"
                      v-if="item.carBrandSuitable"
                    >
                      <!-- <Tooltip
                        :content="item.carBrandSuitable || '-'"
                        theme="light"
                        max-width="200"
                      > -->
                        {{
                          item.carBrandSuitable.split('/')[0] || '-'
                        }}
                        <!-- </Tooltip> -->
                    </div>
                    <div class="name2 tradeline" v-else>
                      <Tooltip :content="'-'" theme="light" max-width="200">
                        <!-- 适用车型:&nbsp; -->
                        {{ '-' }}</Tooltip
                      >
                    </div>
                    <div v-if="token && item.price" class="name3">
                      &yen;{{ item.price }}
                    </div>
                    <div v-if="token && !item.price" class="name3">询价</div>
                    <div v-if="!token" class="name4">登录后查看价格</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="recommend_bottom">
              <ul class="bottom_ul">
                <li
                  v-for="(item, index) in contentlist.slice(-3)"
                  :key="index"
                  @click="enterPAT(item)"
                >
                  <div class="recommend_more">
                    <img class="img1" :src="item.imgurl || blankshop" alt="" />
                  </div>
                  <div class="recommend_morenr">
                    <div class="recommend_morenrtj">
                      <div @click="enterPAT(item)" class="name1 tradeline">
                        <Tooltip
                          :content="item.partComplexName"
                          theme="light"
                          max-width="200"
                        >
                          <p class="p1">
                            {{ item.oeCode }}
                          </p>
                          <p class="p2">{{ item.carBrandName }}</p>
                          <p class="p3">{{ item.stdNameJp }}</p>
                        </Tooltip>
                      </div>
                      <div class="name2 tradeline" v-if="item.carBrandSuitable">
                        <!-- <Tooltip
                          :content="item.carBrandSuitable || '-'"
                          theme="light"
                          max-width="200"
                        > -->
                          {{
                            item.carBrandSuitable.split('/')[0] || '-'
                          }}
                          <!-- </Tooltip> -->
                      </div>
                      <div class="name2 tradeline" v-else>
                        <Tooltip :content="'-'" theme="light" max-width="200">
                          <!-- 适用车型:&nbsp; -->
                          {{ '-' }}</Tooltip
                        >
                      </div>
                      <div v-show="token && item.price" class="name3">
                        &yen;{{ item.price }}
                      </div>
                      <div v-show="token && !item.price" class="name3">
                        询价
                      </div>
                      <div v-show="!token" class="name4">登录后查看价格</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他栏目 -->
      <div v-for="(item, index) in sectionDetail" :key="index">
        <div class="NewProducts w" :id="slideshow ? index + 1 : index">
          <div
            class="common-incon"
            :style="
              item.background == ''
                ? 'background:#FFE9E9'
                : 'background:' + item.background
            "
          >
            <p
              :style="
                item.color == '' ? 'color:#FF515A' : 'color:' + item.color
              "
            >
              {{ item.name }}
            </p>
          </div>
          <div class="recommend">
            <img class="img" :src="item.adverting || adverting" alt="" />
            <div class="recommend_content">
              <div class="recommend_top">
                <ul class="recommend_ul">
                  <li
                    v-for="(item, index) in item.topList.slice(0, 2)"
                    :key="index"
                    @click="enterPAT(item)"
                  >
                    <div class="recommendtp">
                      <img
                        class="imgs"
                        :src="item.imgurl || blankshop"
                        alt=""
                      />
                    </div>
                    <div class="recommend_js">
                      <div @click="enterPAT(item)" class="name1 oneline w33">
                        <Tooltip
                          :content="item.partComplexName"
                          theme="light"
                          max-width="200"
                        >
                          <p class="p1">
                            {{ item.oeCode }}
                          </p>
                          <p class="p2">{{ item.carBrandName }}</p>
                          <p class="p3">{{ item.stdNameJp }}</p>
                          <!-- {{ item.partComplexName }} -->
                        </Tooltip>
                      </div>
                      <div class="name2 tradeline" v-if="item.carBrandSuitable">
                        <!-- <Tooltip
                          :content="item.carBrandSuitable || '-'"
                          theme="light"
                          max-width="200"
                        > -->
                          {{
                            item.carBrandSuitable.split('/')[0] || '-'
                          }}
                          <!-- </Tooltip> -->
                      </div>
                      <div class="name2 tradeline" v-else>
                        <Tooltip :content="'-'" theme="light" max-width="200">
                          <!-- 适用车型:&nbsp; -->
                          {{ '-' }}</Tooltip
                        >
                      </div>
                      <div v-if="token && item.price" class="name3">
                        &yen;{{ item.price }}
                      </div>
                      <div v-if="token && !item.price" class="name3">询价</div>
                      <div v-if="!token" class="name4">登录后查看价格</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="recommend_bottom">
                <ul class="bottom_ul">
                  <li
                    v-for="(item, index) in item.topList.slice(-3)"
                    :key="index"
                    @click="enterPAT(item)"
                  >
                    <div class="recommend_more">
                      <img
                        class="img1"
                        :src="item.imgurl || blankshop"
                        alt=""
                      />
                    </div>
                    <div class="recommend_morenr">
                      <div class="recommend_morenrtj">
                        <div @click="enterPAT(item)" class="name1 tradeline">
                          <Tooltip
                            :content="item.partComplexName"
                            theme="light"
                            max-width="200"
                          >
                            <p class="p1">
                              {{ item.oeCode }}
                            </p>
                            <p class="p2">{{ item.carBrandName }}</p>
                            <p class="p3">{{ item.stdNameJp }}</p>
                            <!-- {{ item.partComplexName }} -->
                          </Tooltip>
                        </div>
                        <div
                          class="name2 tradeline"
                          v-if="item.carBrandSuitable"
                        >
                          <!-- <Tooltip
                            :content="item.carBrandSuitable || '-'"
                            theme="light"
                            max-width="200"
                          > -->
                            {{
                              item.carBrandSuitable.split('/')[0] || '-'
                            }}
                            <!-- </Tooltip> -->
                        </div>
                        <div class="name2 tradeline" v-else>
                          <Tooltip :content="'-'" theme="light" max-width="200">
                            <!-- 适用车型:&nbsp; -->
                            {{ '-' }}</Tooltip
                          >
                        </div>
                        <div v-show="token && item.price" class="name3">
                          &yen;{{ item.price }}
                        </div>
                        <div v-show="token && !item.price" class="name3">
                          询价
                        </div>
                        <div v-show="!token" class="name4">登录后查看价格</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="navigationgd ? 'tznavigationdh' : 'tznavigation'"
        v-show="navigationlist.length > 0"
      >
        <ul class="ul4">
          <li
            v-for="(item, index) in navigationlist"
            :key="index"
            :class="index == partsnavigationxs ? 'color121' : ''"
            @click="partsskip(index)"
          >
            <span class="span1">{{ item.name }}</span>
          </li>
          <li class="li1" @click="backtop">
            <div class="topdh">
              <i class="iconfont icon-jiantoushang"></i>
            </div>
            <div>顶部</div>
          </li>
        </ul>
      </div>
    </div>
    <Slider></Slider>
    <Footer></Footer>
    <FooterP></FooterP>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import {
  getBanner,
  // getNewProductList,
  // getSalesVolume,
  getlistAllGroup,
  getpartsdhdata
} from '../../../api/home'
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
import FooterP from '../common/footer-p.vue'
import Footer from '../common/footer.vue'
import HeaderTop from '../common/header-top.vue'
import HeaderSearch from '../common/header-search.vue'
import Slider from '../common/slider.vue'
export default {
  name: 'home',
  components: {
    HeaderTop,
    HeaderSearch,
    Footer,
    Slider,
    FooterP
  },
  data() {
    return {
      token: Cookies.get(TOKEN_KEY),
      active: 'partsSearch',
      activeName: 'home',
      isUser: this.$store.state.user.userData,
      shoppCarts: '', // 购物车数量
      partscontent: false, // 配件内容显示
      partsthlist: [], //配件的替换
      threelist: [], // 配件的三级替换
      glideglide: -1, // 鼠标经过显示的效果
      offset: 200,
      settingtp: '', // 导航的背景图
      blankshop:
        'https://img.g-part.cn/test/oms/2022/6/17/1655452230731_glnQF0EbF.png', // 空白图
      partsdhlist: [

        {
          id: '00001957',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862009900_kRBPundefinedqOAgc.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863039630_dhnpzundefinedCq3W.svg', //变蓝色
          name: '发动机系统',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610116592_q7h2K9undefinedr6.jpg'
        },
        {
          id: '00001958',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861811344_HAtaqCL.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863028045_hvh02jExY.svg', //变蓝色
          name: '底盘系统',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610109154_CMGGDTs.jpg'
        },
        {
          id: '00001959',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861740723_v4XwBjr1J.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863020338_PgUz8pex6.svg', //变蓝色
          name: '车身系统',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610104848_zTwysLopkE.jpg'
        },
        {
          id: '00001960',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861991026_kCxMpuJ6yt.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863032983_fGidU3cV.svg', //变蓝色
          name: '电器系统',
          imgs: 'https://img.g-part.cn/test/oms/2022/7/1/1656659065961_Bel2FvepY.jpg'
        },
        {
          id: '00001961',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862099542_KyYCcggS8.svg',
          name: '附件',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863303359_FLdFHk1sC.svg', //变蓝色
          imgs: 'https://img.g-part.cn/test/oms/2022/7/1/1656658988194_UGDS9YL.jpg'
        },
        {
          id: '00003005',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862049655_iKl2FAd.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863294375_7fy3yfy.svg', //变蓝色
          name: '辅料'
        },
        {
          id: '00003029',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862028055_JxuP01.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863045724_emrViQK.svg', //变蓝色
          name: '电动力系统'
        },
        {
          id: '00002070',
          icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862069294_OLVLwb.svg',
          icon1:
            'https://img.g-part.cn/test/oms/2022/6/22/1655863299132_vLxvugmTv.svg', //变蓝色
          name: '其他'
        }
      ],

      // partsdhlist: [
      //   {
      //     id: '173',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862009900_kRBPundefinedqOAgc.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863039630_dhnpzundefinedCq3W.svg', //变蓝色

      //     name: '发动机系统',
      //     imgs: 'https://img.g-part.cn/test/oms/2022/7/1/1656659024068_q4J9blvQc.jpg'
      //   },
      //   {
      //     id: '80',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861811344_HAtaqCL.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863028045_hvh02jExY.svg', //变蓝色
      //     name: '底盘件',
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610116592_q7h2K9undefinedr6.jpg'
      //   },
      //   {
      //     id: '1',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861991026_kCxMpuJ6yt.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863032983_fGidU3cV.svg', //变蓝色
      //     name: '电器件',
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610109154_CMGGDTs.jpg'
      //   },

      //   {
      //     id: '128',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655861740723_v4XwBjr1J.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863020338_PgUz8pex6.svg', //变蓝色
      //     name: '车身件',
      //     imgs: 'https://img.g-part.cn/test/oms/2022/7/1/1656659065961_Bel2FvepY.jpg'
      //   },
      //   {
      //     id: '168',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862692663_FEeiSzVx6.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863306977_4IK9JIKe.svg', //变蓝色

      //     name: '油液品',

      //     imgs: 'https://img.g-part.cn/test/oms/2022/7/1/1656658988194_UGDS9YL.jpg'
      //   },
      //   {
      //     id: '125',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862099542_KyYCcggS8.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863303359_FLdFHk1sC.svg', //变蓝色

      //     name: '美容养护品'
      //   },
      //   {
      //     id: '164',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862049655_iKl2FAd.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863294375_7fy3yfy.svg', //变蓝色

      //     name: '汽车用品'
      //   },
      //   {
      //     id: '170',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862028055_JxuP01.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863045724_emrViQK.svg', //变蓝色
      //     name: '汽车油漆'
      //   },
      //   {
      //     id: '168',
      //     icon: 'https://img.g-part.cn/test/oms/2022/6/22/1655862069294_OLVLwb.svg',
      //     icon1:
      //       'https://img.g-part.cn/test/oms/2022/6/22/1655863299132_vLxvugmTv.svg', //变蓝色

      //     name: '汽车工具',
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/19/1655610104848_zTwysLopkE.jpg'
      //   }
      // ],
      // 配件导航数据
      // 轮播图
      // bannerIMG: [
      //   {
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/14/1655205076474_CS8fag0.jpg',
      //     background: '#67aabd'
      //   },
      //   {
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/14/1655205071809_hu5oPqM.jpg',
      //     background: '#263f77'
      //   },
      //   {
      //     imgs: 'https://img.g-part.cn/test/oms/2022/6/21/1655791247045_BsfSIBfMc.jpg',
      //     background: '#426ffe'
      //   }
      // ],

      // 配件导航数据
      // 轮播图
      bannerIMG: [
        {
          imgs: 'https://img.g-part.cn/test/oms/2022/6/14/1655205076474_CS8fag0.jpg',
          background: '#67aabd'
        },
        {
          imgs: 'https://img.g-part.cn/test/oms/2022/6/14/1655205071809_hu5oPqM.jpg',
          background: '#263f77'
        },
        {
          imgs: 'https://img.g-part.cn/test/oms/2022/6/21/1655791247045_BsfSIBfMc.jpg',
          background: '#426ffe'
        }
      ],
      navigationlist: [], //导航数据
      xiamianlist: [
        {
          id: '1',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859280785_BPn1UgJ.png',
          name1: '壳牌（Shell）蓝喜力全',
          name2:
            '宝来凌渡朗逸宝来凌渡宝来凌渡朗逸宝来凌渡宝来凌渡朗逸宝来凌渡宝来凌渡朗逸宝来凌渡宝来凌渡朗逸宝来凌渡',
          name3: '￥218.00'
        },
        {
          id: '2',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859339630_CJiyNuUrR.png',
          name1: '壳牌（Shell',
          name2: '宝来 凌渡 朗逸 波罗桑塔纳',
          name3: '￥218.00'
        },
        {
          id: '3',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859307806_pD4n75sY.png',
          name1: '壳牌（Shell）蓝喜力全合成发动机 油 Helix HX7 PLUS',
          name2: '宝来 凌渡 朗逸 波罗桑塔纳',
          name3: '￥218.00'
        },
        {
          id: '4',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859302463_c6DPEujAP.png',
          name1: '壳牌（Shell）蓝喜力全合成发动机 油 Helix HX7 PLUS',
          name2: '宝来 凌渡 朗逸 波罗桑塔纳 ',
          name3: '￥218.00'
        }
      ], // 推荐下面的数据
      hotdata: {}, // 热销数据
      adverting1:
        'https://img.g-part.cn/test/oms/2022/6/18/1655542651206_247vKX7tf.png', // 热销的代替图  https://img.g-part.cn/test/oms/2022/6/17/1655454163241_FX0NmtTy.png   https://img.g-part.cn/test/oms/2022/6/17/1655452230731_glnQF0EbF.png
      adverting: '', // 热销图的
      hotparts: false, // 热销数据
      sectionDetail: [], // 动态的渲染
      partstwoxs: '', // 二级配件显示
      partsoneid: '', // 第一级的id
      partstwoid: '', // 第一级的id
      partsthreeid: '', // 第一级的id
      partstwolist: [], // 第二级的数据
      partsthreexs: '', // 三级配件显示
      partsthreelist: [], // 第三级的数据
      navigationgd: false, // 导航滚动
      partsnavigationxs: '', // 配件导航颜色
      bannerconter: false, // 显示banner的内容
      slideshow: false, // 滑动显示
      phonedt: [
        {
          id: '1',
          color: '#2688EA',
          background: '#F2F8FE',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/29/1656489460999_KPv9IHIs.png'
        },
        {
          id: '2',
          color: '#FF4F1A',
          background: '#FFF5F2',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/17/1655455881626_FARUK2v9.png'
        },
        {
          id: '3',
          color: '#F5AB19',
          background: '#FEFAF1',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/17/1655454163241_FX0NmtTy.png'
        },
        {
          id: '4',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        },
        {
          id: '5',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        },
        {
          id: '6',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        },
        {
          id: '7',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        },
        {
          id: '8',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        },
        {
          id: '9',
          color: '#FF515A',
          background: '#FFE9E9',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/18/1655541997326_kpTptX0Z.jpg'
        }
      ], // 动态图片以及背景
      contentlist: [
        {
          id: '1',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859298315_1tP0XL.png',
          name1:
            '马勒PM2.5活性炭空调滤 LAK709阿萨德输入的共同特殊的人str石头人员str 月收入统一铜仁市送人头羊肉汤的是',
          name2:
            '新飞度08年后/锋范/ 哥瑞/凌派/XRV/缤智大家反馈是个地方火锅说的入库活动日喝口水都好的',
          name3: '￥78.00'
        },
        {
          id: '2',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859343360_RI8uc8.png',
          name1: '马勒PM2.5活性炭空调滤 LAK709',
          name2: '新飞度08年后/锋范/ 哥瑞/凌派/XRV/缤智',
          name3: '￥78.00'
        },
        {
          id: '3',
          imgs: 'https://img.g-part.cn/test/oms/2022/6/10/1654859302463_c6DPEujAP.png',
          name1: '马勒PM2.5活性炭空',
          name2: '新飞度08年后/锋范/ 哥瑞/凌派/XRV/缤智',
          name3: '￥78.00'
        }
      ], // 推荐的内容
      // 新品推荐
      NewProductslist: [],
      // 热销配件
      HotPartsList: []
      // 推荐品牌
    }
  },
  created() {
    // this.getNewProductList()
    // this.getSalesVolume()
    this.partsdhdata()
    this.sidebarsj()
  },
  methods: {
    // 轮播图
    // async getBanner() {
    //   const res = await getBanner({ platformCode: 'JP-WSS' })
    //   console.log('轮播图---', res)
    //   if (res.status) {
    //     this.bannerIMG = res.data.list
    //   } else {
    //     this.$Message.error(res.message)
    //   }
    // },
    // 侧边栏数据
    async sidebarsj() {
      const res = await getpartsdhdata()
      console.log(res, '萨科技的 ')
      if (res.status) {
        // this.hotparts = false
        // res.data.hot = null
        this.hotparts = res.data.hot
        this.navigationlist = res.data.sectionList
        // console.log(this.navigationlist)
        // console.log(this.navigationlist.length)
        if (res.data.hot == null) {
        } else {
          this.contentlist = res.data.hot.topList
          // this.xiamianlist = res.data.hot.belowList
          this.adverting = res.data.hot.adverting
        }
        if (this.hotparts) {
          this.slideshow = true
        } else {
          this.slideshow = false
        }

        this.sectionDetail = res.data.sectionDetail
        this.sectionDetail.forEach((item, ind) => {
          item.adverting = this.phonedt[ind].imgs
          item.color = this.phonedt[ind].color
          item.background = this.phonedt[ind].background
        })
      }
    },
    // 配件的导航数据
    async partsdhdata() {
      const res = await getlistAllGroup()
      this.partsthlist = res.data.world
      this.threelist = res.data.level2First
    },
    // 鼠标移入显示第一级数据
    mouseover(value, imgs, index) {
      this.glideglide = index
      this.partsoneid = value
      this.settingtp = imgs
      this.partstwolist = this.partsthlist[value]
      this.partsthreelist = this.threelist[value]
      this.bannerconter = true
      this.partstwoxs = 0
    },
    // 鼠标移出显示的第一级数据
    mouseleave() {
      this.bannerconter = false
      this.glideglide = -1
    },
    // 第三级数据
    threeparts(value, index) {
      this.partstwoid = value
      this.partsthreelist = this.partsthlist[value]
      this.partstwoxs = index
      this.partsthreexs = 0
    },
    // 跳转配件主要查询
    skipparts(value, index, item) {
      this.partsthreeid = value
      this.partsthreexs = index
      const data = {
        a: this.partsoneid,
        b: item.parentId,
        c: this.partsthreeid
      }
      // let dataobj = JSON.stringify(data)
      this.$router.push({
        path: '/partsNavigation',
        query: {
          obj: JSON.stringify(data)
          // obj: {
          //   a: this.partsoneid,
          //   b: this.partstwoid,
          //   c: this.partsthreeid
          // }
        }
      })
      // partsclassify
    },
    // 首页跳转
    partsskip(value) {
      console.log(value, '啥的接口啥')
      this.partsnavigationxs = value
      console.log(value)
      let jumpitem = document.getElementById(value).offsetTop
      console.log(jumpitem)
      // this.$nextTick(() => {
      window.scroll({
        top: jumpitem - 40 //向上移动的距离，如果有fixede布局， 直接减去对应距离即可
        // behavior: 'smooth' // 平滑移动
      })
      // })
    },
    // 滑动跳转
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      scrollTop = scrollTop + 50
      if (scrollTop > 480) {
        this.navigationgd = true
      } else {
        this.navigationgd = false
      }
      let scrollItems = document.querySelectorAll('.NewProducts')
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        if (scrollTop >= scrollItems[i].offsetTop) {
          this.partsnavigationxs = scrollItems[i].id
          return
        }
      }
    },
    // 返回顶部
    backtop() {
      let scrollToptimer = setInterval(function () {
        let top = document.body.scrollTop || document.documentElement.scrollTop
        let speed = top / 6
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed
        } else {
          document.documentElement.scrollTop -= speed
        }
        if (top == 0) {
          clearInterval(scrollToptimer)
        }
      }, 30)
    },
    // 新品推荐
    // async getNewProductList() {
    //   const res = await getNewProductList()
    //   console.log('新品列表---', res)
    //   if (res.code == '200') {
    //     this.NewProductslist = res.data.list
    //   }
    // },
    // 热销配件
    // async getSalesVolume() {
    //   const res = await getSalesVolume(9)
    //   console.log('热销配件----', res)
    //   if (res.status) {
    //     this.HotPartsList = res.data.list
    //   } else {
    //     console.log(this.res.message)
    //   }
    // },
    enterPAT(item) {
      // console.log(oeCode)
      this.$router.push({
        path: '/partsSearch',
        query: {
          searchContent: item.oeCode,
          partType: item.qualityTypeId,
          brandId: item.carBrandId
        }
      })
    }
  },
  async mounted() {
    // await this.getBanner()
    var mySwiper = new Swiper('.swiper-container', {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      effect: 'fade',
      // 轮播图的方向，也可以是vertical方向
      direction: 'horizontal',
      //环形切换关闭
      loop: true,
      // 切换的速度
      speed: 200, //滑动或者自动换页时的速度
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        clickable: true
        // dynamicBullets: true
      },
      paginationClickable: true, // 这样，即使我们滑动之后， 定时器也不会被清除
      autoplayDisableOnInteraction: false,
      // on: {
      //   //滑动调用该方法
      //   slideChangeTransitionEnd: function () {
      //     var slide = this.activeIndex
      //     //测试用
      //     //	        		alert("当前位置："+slide);//滑动结束时，告诉我现在是第几个slide（第几页）
      //   }
      // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })
    //鼠标移出隐藏按钮，移入显示按钮
    // mySwiper.el.onmouseover = function () {
    //   mySwiper.navigation.$nextEl.removeClass('hide')
    //   mySwiper.navigation.$prevEl.removeClass('hide')
    // }
    // mySwiper.el.onmouseout = function () {
    //   mySwiper.navigation.$nextEl.addClass('hide')
    //   mySwiper.navigation.$prevEl.addClass('hide')
    // }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
.home {
  background-color: #f2f4f5;
  position: relative;
  .tznavigation {
    position: absolute;
    top: 584px;
    left: 50%;
    margin-left: 615px;
    width: 56px;
    border-radius: 3px;
    // margin-left: 615px;
    background-color: #fff;
    box-shadow: 0 0 1px rgb(0 0 0 / 10%);
    overflow: hidden;
    z-index: 3;
    .ul4 {
      border-radius: 2px;
      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        text-align: center;
        width: 56px;
        height: 56px;
        padding: 0px 8px;
        line-height: 14px;
        &:hover {
          color: #377cf1;
        }
        .span1 {
          cursor: pointer;
          width: 40px;
          height: 56px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #cccccc;
        }
      }
      .li1 {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 56px;
        height: 56px;
        border-bottom: none;
        .topdh {
          margin-top: 10px;
          text-align: center;
          margin-bottom: 5px;
          .icon-jiantoushang {
            font-size: 16px;
          }
        }
      }
    }
    .color121 {
      color: #ffffff;
      background: linear-gradient(121deg, #50b9ff 0%, #4469ff 100%);
      &:hover {
        color: #ffffff !important;
      }
      .span1 {
        cursor: pointer;
        width: 40px;
        height: 56px;
        display: flex;
        align-items: center;
        border: none !important;
      }
    }
  }
  .tznavigationdh {
    position: fixed;
    top: 60px;
    left: 50%;
    margin-left: 615px;
    width: 56px;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0 0 1px rgb(0 0 0 / 10%);
    overflow: hidden;
    z-index: 3;
    .ul4 {
      border-radius: 2px;
      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        text-align: center;
        width: 56px;
        height: 56px;
        padding: 0px 8px;
        line-height: 14px;
        &:hover {
          color: #377cf1;
        }
        .span1 {
          cursor: pointer;
          width: 40px;
          height: 56px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #cccccc;
        }
      }
      .li1 {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 56px;
        height: 56px;
        border-bottom: none;
        .topdh {
          margin-top: 10px;
          text-align: center;
          margin-bottom: 5px;
          .icon-jiantoushang {
            font-size: 16px;
          }
        }
      }
    }
    .color121 {
      color: #ffffff;
      background: linear-gradient(121deg, #50b9ff 0%, #4469ff 100%);
      &:hover {
        color: #ffffff !important;
      }
      .span1 {
        cursor: pointer;
        width: 40px;
        height: 56px;
        display: flex;
        align-items: center;
        border: none !important;
      }
    }
  }
  .top,
  .bottom {
    text-align: center;
  }
  .center {
    width: 300px;
    margin: 10px auto;
    overflow: hidden;
  }
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clearfix {
    overflow: hidden;
    _zoom: 1;
  }
  .common-incon {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 60px;
    padding: 12px 18px;
    // background: #fefaf1;
    p {
      display: inline-block;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      // color: #f5ab19;
      opacity: 1;
    }
  }
  .cultivation {
    display: flex;
  }
  // 全部商品列表
  .banner {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .allshop {
      position: absolute;
      top: -36px;
      height: 36px;
      line-height: 36px;
      width: 220px;
      height: 36px;
      background: #377cf1;
      border-radius: 4px 4px 0px 0px;
      .icon-liebiao {
        color: #ffffff;
        font-size: 16px;
        margin-left: 15px;
        margin-right: 9px;
      }
      .shopplist {
        width: 96px;
        height: 16px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #ffffff;
        opacity: 1;
      }
    }
    .partsdh {
      position: absolute;
      z-index: 2;
      .navigationbanner {
        display: flex;
        .ul1 {
          width: 220px;
          height: 380px;
          background-color: #2a5675;
          li {
            cursor: pointer;
            width: 220px;
            height: 42px;
            color: #ffffff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            // opacity: 0.5;
            font-weight: 400;
            padding: 13px 0 13px 8px;
            z-index: 2;
            &:last-child {
              border-bottom: none;
            }
            .inconkd {
              display: inline-block;
              width: 30px !important;
              margin-right: 13px;
              text-align: center;
              font-size: 16px;
              .iconfont {
                opacity: 0.8 !important;
                margin-right: 13px;
              }
            }
            .w112 {
              cursor: pointer;
            }
            .icon-youjiantou {
              color: #ffffff;
              float: right;
              margin-right: 13px;
            }
          }
        }
        .partscontent {
          display: flex;
          flex-direction: column;
          width: 980px;
          height: 380px;
          background-color: #fff;
          // opacity: 0.9;
          // filter: alpha(opacity=90);
          // -moz-opacity: 0.9;
          .twopartssj {
            .ul2 {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              width: 980px;
              // height: 48px;
              padding: 3px 0 0 14px;
              li {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 10px;
                font-size: 14px;
                height: 26px;
                font-family: Source Han Sans CN;
                padding: 6px 8px;
                font-weight: 500;
                color: #377cf1;
                border: 1px solid #377cf1;
                margin-top: 8px;
                &:hover {
                  color: #ffffff;
                  background-color: #377cf1;
                }
              }
              .color177 {
                color: #ffffff;
                background-color: #377cf1;
              }
            }
          }
          .threepartssj {
            padding: 18px 0 0 20px;
            .ul3 {
              display: flex;
              flex-wrap: wrap;
              width: 980px;
              li {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;
                height: 30px;
                // width: 100%;
                // width: 70px;
                height: 21px;
                line-height: 21px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #787878;
                margin-top: 14px;
                &:hover {
                  color: #377cf1;
                }
              }
              .color177 {
                color: #377cf1;
              }
            }
          }
        }
      }
    }
  }
  // 轮播图
  .swiper-container {
    width: 100%;
    height: 380px;
    margin-bottom: 20px;
    .swiper-wrapper {
      // position: relative;
      // width: 1200px;
      // margin: 0 auto;
      text-align: center;
      width: 100%;
      height: 100%;
      .swiper-slide {
        .picture {
          width: 1200px;
          margin: 0 auto;
          position: relative;
          .imgs3 {
            vertical-align: middle;
            width: 1200px;
            height: 100%;
          }
          .swiper-pagination {
            position: absolute;
            top: 93%;
            left: 50%;
            width: 120px !important;
            text-align: center;
            // height: 35px;
            border-radius: 2px;
            transition: opacity 0.5s;
          }
          .swiper-button-prev {
            position: absolute;
            top: 50%;
            left: 240px;
            width: 35px;
            height: 35px;
            border-radius: 2px;
            transition: opacity 0.5s;
          }
          .swiper-button-next {
            position: absolute;
            top: 50%;
            right: 20px;
            width: 35px;
            height: 35px;
            border-radius: 2px;
            transition: opacity 0.5s;
          }
        }
      }
    }
    .hide {
      opacity: 0;
    }
    .swiper-button-next {
      background: url('../../../assets/images/home/arrow_right_hover.png')
        no-repeat center;
    }
    .swiper-button-prev {
      background: url('../../../assets/images/home/arrow_left_hover.png')
        no-repeat center;
    }
    // .swiper-button-next,
    // .swiper-button-prev {
    //   width: 35px;
    //   height: 35px;
    //   border-radius: 2px;
    //   transition: opacity 0.5s;
    // }
    /deep/.swiper-pagination-bullet-active {
      margin: 0 2px !important;
      height: 12px;
      width: 12px;
      border: 3px solid #fff;
      border-radius: 50%;
      opacity: 0.8;
      // background: #007aff;
      background: hsla(0, 0%, 100%, 0.3);
    }
    /deep/.swiper-pagination-bullet {
      margin-right: 10px !important;
    }
  }

  .slidecontent {
    margin-top: 10px;
    // background-color: skyblue;
  }
  // 新品推荐
  .NewProducts {
    margin-top: 10px;
    // 导航
    .tznavigation {
      position: absolute;
      top: 0;
      right: -66px;
      width: 56px;
      border-radius: 3px;
      // margin-left: 615px;
      background-color: #fff;
      box-shadow: 0 0 1px rgb(0 0 0 / 10%);
      overflow: hidden;
      z-index: 3;
      .ul4 {
        border-radius: 2px;
        li {
          cursor: pointer;
          display: flex;
          align-items: center;
          text-align: center;
          width: 56px;
          height: 56px;
          padding: 0px 8px;
          line-height: 14px;
          &:hover {
            color: #377cf1;
          }
          .span1 {
            cursor: pointer;
            width: 40px;
            height: 56px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #cccccc;
          }
        }
        .li1 {
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 56px;
          height: 56px;
          border-bottom: none;
          .topdh {
            margin-top: 10px;
            text-align: center;
            margin-bottom: 5px;
            .icon-jiantoushang {
              font-size: 16px;
            }
          }
        }
      }
      .color121 {
        color: #ffffff;
        background: linear-gradient(121deg, #50b9ff 0%, #4469ff 100%);
        &:hover {
          color: #ffffff !important;
        }
        .span1 {
          cursor: pointer;
          width: 40px;
          height: 56px;
          display: flex;
          align-items: center;
          border: none !important;
        }
      }
    }
    .tznavigationdh {
      position: fixed;
      top: 60px;
      left: 50%;
      margin-left: 615px;
      width: 56px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0 0 1px rgb(0 0 0 / 10%);
      overflow: hidden;
      z-index: 3;
      .ul4 {
        border-radius: 2px;
        li {
          cursor: pointer;
          display: flex;
          align-items: center;
          text-align: center;
          width: 56px;
          height: 56px;
          padding: 0px 8px;
          line-height: 14px;
          &:hover {
            color: #377cf1;
          }
          .span1 {
            cursor: pointer;
            width: 40px;
            height: 56px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #cccccc;
          }
        }
        .li1 {
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 56px;
          height: 56px;
          border-bottom: none;
          .topdh {
            margin-top: 10px;
            text-align: center;
            margin-bottom: 5px;
            .icon-jiantoushang {
              font-size: 16px;
            }
          }
        }
      }
      .color121 {
        color: #ffffff;
        background: linear-gradient(121deg, #50b9ff 0%, #4469ff 100%);
        &:hover {
          color: #ffffff !important;
        }
        .span1 {
          cursor: pointer;
          width: 40px;
          height: 56px;
          display: flex;
          align-items: center;
          border: none !important;
        }
      }
    }
    // 新品推荐的内容
    .recommend {
      display: flex;
      .img {
        width: 190px;
        height: 360px;
      }
      .recommend_content {
        flex: 1;
        display: flex;
        background: #ffffff;
        .recommend_top {
          width: 404px;
          border-right: 1px solid #dcdfe9;
          .recommend_ul {
            // display: flex;
            li {
              cursor: pointer;
              display: flex;
              width: 404px;
              height: 180px;
              // border-right: 1px solid #dcdfe9;
              border-bottom: 1px solid #dcdfe9;
              &:last-child {
                border-bottom: none;
              }
              .recommendtp {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 170px;
                height: 150px;
                margin: 15px 10px;
                .imgs {
                  // width: 100%;
                  // height: 100%;
                  // object-fit: cover;
                  max-width: 120px;
                  max-height: 160px;
                }
              }
              .recommend_js {
                cursor: pointer;
                flex: 1;
                // width: 142.5px;
                margin-top: 22px;
                .name1 {
                  width: 190px;
                  height: 66px;
                  font-size: 14px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  line-height: 16px;
                  color: #444650;
                  display: table-cell;
                  vertical-align: bottom;
                  padding-bottom: 6px;
                  border-bottom: 1px solid #e2e2e2;
                  /deep/ .ivu-tooltip {
                    .ivu-tooltip-rel {
                      overflow: hidden;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      display: -webkit-box; // 作为弹性伸缩盒子模型显示
                      -webkit-line-clamp: 4; // 显示的行
                      -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直
                    }
                  }
                  p {
                    max-width: 197px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-break: break-all;
                    word-wrap: break-word;
                    -webkit-line-clamp: 2; // 显示的行
                  }
                  .p1 {
                    font-weight: 500;
                    color: #377cf1;
                  }
                  .p2 {
                    font-weight: 500;
                    color: #444650;
                    padding: 3px 0;
                  }
                  .p3 {
                    font-size: 12px;
                    color: #a4a6b1;
                  }
                }
                .name2 {
                  width: 197px;
                  height: 28px;
                  font-size: 12px;
                  margin-top: 5px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  line-height: 15px;
                  color: #a4a6b1;
                  /deep/ .ivu-tooltip {
                    .ivu-tooltip-rel {
                      overflow: hidden;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      display: -webkit-box; // 作为弹性伸缩盒子模型显示
                      -webkit-line-clamp: 2; // 显示的行
                      -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
                    }
                  }
                  /deep/ .ivu-tooltip-popper {
                    .ivu-tooltip-content {
                      .ivu-tooltip-inner {
                        max-height: 200px;
                        overflow: auto;
                      }
                      ::-webkit-scrollbar {
                        /*滚动条整体粗细样式*/
                        /*高宽分别对应横竖滚动条的尺寸*/
                        width: 6px;
                        height: 4px;
                      }

                      /*滚动条里面小方块*/
                      ::-webkit-scrollbar-thumb {
                        border-radius: 5px !important;
                        // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
                        /* 颜色 */
                        background: #c1c1c1 !important;
                        /* 线性渐变背景 */
                        // background-image: #C1C1C1!important;
                      }

                      /*滚动条轨道*/
                      ::-webkit-scrollbar-track {
                        border-radius: 10px !important;
                        // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
                        // background: rgba(0,0,0,.1) !important;
                      }
                    }
                  }
                }
                .name3 {
                  // width: 43px;
                  // height: 16px;
                  font-size: 22px;
                  // margin-top: 33px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  // line-height: 0px;
                  color: #f62b4e;
                  padding-top: 10px;
                }
                .name4 {
                  padding-top: 10px;
                  // width: 98px;
                  // height: 14px;
                  font-size: 22px;
                  margin-top: 33px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  line-height: 0px;
                  color: #f62b4e;
                  opacity: 1;
                }
              }
            }
          }
        }
        .recommend_bottom {
          width: 606px;
          .bottom_ul {
            display: flex;
            // width: 1010px;
            li {
              cursor: pointer;
              // display: flex;
              width: 202px;
              height: 360px;
              border-right: 1px solid #dcdfe9 !important;
              &:last-child {
                border-right: none !important;
              }
              .recommend_more {
                // margin-top: 20px;
                // width: 170px;
                height: 150px;
                // padding: 15px 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 170px;

                .img1 {
                  max-width: 120px;
                  max-height: 160px;
                }
              }
              .recommend_morenr {
                padding: 0 12px;
                .recommend_morenrtj {
                  flex: 1;
                  // width: 142.5px;
                  margin-top: 8px;
                  .name1 {
                    width: 174px;
                    height: 101px;
                    display: table-cell;
                    vertical-align: bottom;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    line-height: 16px;
                    color: #444650;
                    display: table-cell;
                    vertical-align: bottom;
                    // padding: 0 3px;
                    padding-bottom: 6px;

                    border-bottom: 1px solid #e2e2e2;
                    /deep/ .ivu-tooltip {
                      .ivu-tooltip-rel {
                        height: 101px;
                        display: table-cell;
                        vertical-align: bottom;
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        // display: -webkit-box; // 作为弹性伸缩盒子模型显示
                        -webkit-line-clamp: 4; // 显示的行
                        -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直
                      }
                    }
                    p {
                      max-width: 174px;

                      overflow: hidden;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      display: -webkit-box; // 作为弹性伸缩盒子模型显示
                      -webkit-line-clamp: 2; // 显示的行
                      -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
                    }
                    .p1 {
                      font-weight: 500;
                      color: #377cf1;
                    }
                    .p2 {
                      font-weight: 500;
                      color: #444650;
                      padding: 2px 0;
                    }
                    .p3 {
                      font-size: 12px;
                      color: #a4a6b1;
                    }
                  }
                  .name2 {
                    // border-top: 1px solid #000;
                    width: 174px;
                    height: 28px;
                    font-size: 12px;
                    margin-top: 5px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    line-height: 15px;
                    color: #a4a6b1;
                    /deep/ .ivu-tooltip {
                      .ivu-tooltip-rel {
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box; // 作为弹性伸缩盒子模型显示
                        -webkit-line-clamp: 2; // 显示的行
                        -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
                      }
                    }
                    /deep/ .ivu-tooltip-popper {
                      .ivu-tooltip-content {
                        .ivu-tooltip-inner {
                          max-height: 200px;
                          overflow: auto;
                        }
                        ::-webkit-scrollbar {
                          /*滚动条整体粗细样式*/
                          /*高宽分别对应横竖滚动条的尺寸*/
                          width: 6px;
                          height: 4px;
                        }

                        /*滚动条里面小方块*/
                        ::-webkit-scrollbar-thumb {
                          border-radius: 5px !important;
                          // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
                          /* 颜色 */
                          background: #c1c1c1 !important;
                          /* 线性渐变背景 */
                          // background-image: #C1C1C1!important;
                        }

                        /*滚动条轨道*/
                        ::-webkit-scrollbar-track {
                          border-radius: 10px !important;
                          // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
                          // background: rgba(0,0,0,.1) !important;
                        }
                      }
                    }
                  }
                  .name3 {
                    // width: 43px;
                    // height: 16px;
                    font-size: 22px;
                    padding-top: 10px;
                    // margin-top: 33px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    // line-height: 0px;
                    color: #f62b4e;
                  }
                  .name4 {
                    // width: 98px;
                    // height: 14px;
                    padding-top: 10px;
                    font-size: 22px;
                    margin-top: 33px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    line-height: 0px;
                    color: #f62b4e;
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  // 两行换行
  .tradeline {
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; // 作为弹性伸缩盒子模型显示
    -webkit-line-clamp: 2; // 显示的行
    -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
  }
  // 一行换行
  .oneline {
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; // 作为弹性伸缩盒子模型显示
    -webkit-line-clamp: 4; // 显示的行
    -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
  }
  .color10c {
    color: #10c896;
  }
  .backFE {
    background: #f1fcf9;
  }
  .color377 {
    background-color: #fff;
    span {
      color: #377cf1 !important;
      // background-color: red;
      // img {
      //   color: #377cf1 !important;
      //   background-color: #377cf1;
      // }
    }
    // .inconkd {
    //   .iconfont {
    //     opacity: 1 !important;
    //   }
    // }
    .icon-youjiantou {
      display: none !important;
    }
  }
  // 推荐品牌
  .RecommendedBrand {
    .RecommendedBrand-imgs {
      border-left: 1px solid #e2e2e2;
      ul {
        border-top: 1px solid #e2e2e2;
        li {
          cursor: pointer;
          float: left;
          width: 10%;
          border-right: 1px solid #e2e2e2;
          border-bottom: 1px solid #e2e2e2;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  // 推荐店铺
  .RecommendStore {
    margin-top: 20px;
    ul {
      border-top: 1px solid #e2e2e2;
      border-left: 1px solid #e2e2e2;
      li {
        cursor: pointer;
        float: left;
        width: 33.3%;
        a {
          width: 100%;
          height: 100%;
          img {
            width: 120px;
            height: 120px;
          }
          .RecommendStore-div {
            padding: 16px 0 14px 17px;
            border-right: 1px solid #e2e2e2;
            border-bottom: 1px solid #e2e2e2;
            // border: 1px solid #e2e2e2;
            // height: 600px;
          }
        }
      }
    }
  }
}
</style>
